"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderTotals_1 = require("./OrderTotals");
exports.default = OrderTotals_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/OrderTotals/index.js
// module id = 2385
// module chunks = 8